import { render, staticRenderFns } from "./oAddressField.vue?vue&type=template&id=70939f67&scoped=true&"
import script from "./oAddressField.vue?vue&type=script&lang=js&"
export * from "./oAddressField.vue?vue&type=script&lang=js&"
import style0 from "./oAddressField.vue?vue&type=style&index=0&id=70939f67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70939f67",
  null
  
)

export default component.exports